var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { action, observable, runInAction, set, configure } from "mobx";
import { isNotBlankArray } from "../../../utils/array";
const LOAD_LIMIT = 20;
configure({ isolateGlobalState: true, enforceActions: "observed" });
export default class ProductStore {
    constructor(modules) {
        this.productsListMap = {};
        this.isLoadEnd = {};
        this.isLoadingProducts = {};
        this.productsLoadMore = {};
        this.productsLimit = {};
        this.offset = {};
        this.exposureProductListMap = {};
        this.getLimit = (poolId) => {
            var _a;
            if (this.productsLoadMore[poolId]) {
                return this.productsLimit[poolId];
            }
            const productLimit = this.productsLimit[poolId] - (((_a = this.productsListMap[poolId]) === null || _a === void 0 ? void 0 : _a.length) || 0);
            return Math.min(productLimit, LOAD_LIMIT);
        };
        this.loadProductsList = (poolId, onLoadPool) => __awaiter(this, void 0, void 0, function* () {
            var _a;
            if (this.isLoadingProducts[poolId] || this.isLoadEnd[poolId]) {
                return;
            }
            set(this.isLoadingProducts, { [poolId]: true });
            try {
                const productLimit = this.getLimit(poolId);
                const res = yield onLoadPool({
                    poolId,
                    limit: `${productLimit}`,
                    offset: (this.offset[poolId] || 0).toString(),
                    prmPosition: ((_a = this.productsListMap[poolId]) === null || _a === void 0 ? void 0 : _a.length) || 0,
                });
                if (isNotBlankArray(res === null || res === void 0 ? void 0 : res.products)) {
                    runInAction("update product list", () => {
                        set(this.offset, {
                            [poolId]: this.offset[poolId] + productLimit,
                        });
                        if (!this.productsListMap[poolId]) {
                            set(this.productsListMap, { [poolId]: res.products });
                        }
                        else {
                            set(this.productsListMap, {
                                [poolId]: this.productsListMap[poolId].concat(res.products),
                            });
                        }
                        if (!res.hasNext ||
                            (this.productsListMap[poolId] &&
                                this.productsListMap[poolId].length >= this.productsLimit[poolId] &&
                                !this.productsLoadMore[poolId])) {
                            set(this.isLoadEnd, { [poolId]: true });
                        }
                    });
                }
                else {
                    runInAction(() => {
                        set(this.isLoadEnd, { [poolId]: true });
                    });
                }
                return res === null || res === void 0 ? void 0 : res.products;
            }
            catch (e) {
                console.error("GetProducts Got error", e);
            }
            finally {
                runInAction(() => {
                    set(this.isLoadingProducts, { [poolId]: false });
                });
            }
            return [];
        });
        this.handleExposureProductList = (mapKey, productList) => {
            if (mapKey) {
                set(this.exposureProductListMap, { [mapKey]: productList });
            }
        };
        modules.forEach(item => {
            const hasElements = isNotBlankArray(item.productElements);
            const mapKey = `${item.poolId}`;
            set(this.productsListMap, {
                [mapKey]: item.productElements || [],
            });
            set(this.productsLoadMore, { [mapKey]: item.canLoadMore });
            const maxLimit = item.maxLoad;
            set(this.offset, { [mapKey]: hasElements ? Math.min(LOAD_LIMIT, maxLimit) : 0 });
            set(this.isLoadEnd, {
                [mapKey]: hasElements ? item.productElements.length === maxLimit : false,
            });
            if (!item.canLoadMore) {
                set(this.productsLimit, { [mapKey]: maxLimit });
            }
            else {
                set(this.productsLimit, { [mapKey]: LOAD_LIMIT });
            }
        });
    }
}
__decorate([
    observable
], ProductStore.prototype, "productsListMap", void 0);
__decorate([
    observable
], ProductStore.prototype, "isLoadEnd", void 0);
__decorate([
    observable
], ProductStore.prototype, "isLoadingProducts", void 0);
__decorate([
    observable
], ProductStore.prototype, "productsLoadMore", void 0);
__decorate([
    observable
], ProductStore.prototype, "productsLimit", void 0);
__decorate([
    observable
], ProductStore.prototype, "offset", void 0);
__decorate([
    observable
], ProductStore.prototype, "exposureProductListMap", void 0);
__decorate([
    action
], ProductStore.prototype, "getLimit", void 0);
__decorate([
    action
], ProductStore.prototype, "loadProductsList", void 0);
__decorate([
    action
], ProductStore.prototype, "handleExposureProductList", void 0);
